export class LifestyleDetectionCache {
  static showCacheKey(imageUrl: string) {
    return `lifestyle-detection-${imageUrl}`;
  }

  static searchImageUrlCacheKey() {
    return 'search-image-url-lifestyle-detection-cache';
  }
}
